import { SweetAlertResult } from 'sweetalert2'
import Message from "@/const/Message"
import { DialogService } from "./DialogService"
import Config from '@/const/Config'
import { AxiosError } from 'axios'

export class UtilService {

  /**
   * 認証エラーダイアログを表示します
   */
  public static async showAuthErrorDialog(redirect = true) {
    await DialogService.error({
      text: Message.ERROR_AUTH_FAILURE,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false
    }, true).then((result: SweetAlertResult) => {
      if (result.isConfirmed) {
        if(redirect){
          // 閉じたらログアウトしてログインフォーム
          location.href = Config.LOGOUT_URL
        }
      }
    })
  }

  /**
   * レスポンスのエラーメッセージをダイアログで表示します
   * @param e
   */
  public static async showResponseErrorDialog(e: AxiosError<any>) {
    const messages = []
    if (e.response && e.response.data && e.response.data.errors) {
      const err = e.response.data.errors
      for (let key in err) {
        for (let idx = 0; idx < err[key].length; idx++) {
          messages.push(err[key][idx])
        }
      }
    }
    if (messages.length === 0) {
      messages.push(Message.ERROR_UNEXPECTED)
    }
    await DialogService.error({
      html: messages.join('<br>'),
      customClass: {
        htmlContainer: 'error-multiline'
      }
    }, true)
  }

}
